module.exports = __webpack_public_path__ + "static/media/europe02.907abe09.jpg";